import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { BusinessQrcodeScannerPage } from '../business-qrcode-scanner/business-qrcode-scanner';
import { ConsumerProfilePage } from '../../pages/consumer-profile/consumer-profile';


@Component({
  selector: 'page-stamper-main',
  templateUrl: 'stamper-main.html',
})
export class StamperMainPage {
  qrCodeScanner = BusinessQrcodeScannerPage;
  profile = ConsumerProfilePage;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad StamperMainPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/stamper-main/stamper-main.ts